<template>
  <div>
    <listPagesHeader
      :page-title="$t('list.headers.accepted_families')"
      :show-btn="false"
    />
    <div class="page-content-paddings">
      <v-layout>
        <FiltersBar
          :filters-values-id="2"
          :page-limit="getQualifiedFamilies.pagination.amount"
        />
      </v-layout>
      <v-layout
        class="list-header"
        :align-center="xsOnly"
      >
        <v-flex
          shrink
          :class="{ xs12: xsOnly }"
          class="d-layout"
        >
          <h3 class="d-inline-block">
            {{ $t('message.my_families') }}
            <span v-if="!getQualifiedFamilies.isLoading">({{ getQualifiedFamilies.amount }})</span>
          </h3>
        </v-flex>
      </v-layout>
      <v-layout>
        <p class="mt-2 mb-0">
          {{ $t('instructions.accepted') }}
        </p>
      </v-layout>
      <MyFamiliesTable
        :is-loading="getQualifiedFamilies.isLoading"
        :headers="myFamilies.headers"
        :items="getQualifiedFamilies.data"
        @sorting="fetchMyFamilies"
      />
      <BasePagination
        :pagination="getQualifiedFamilies.pagination"
        :amount-all="amountAll"
        @page="setPage"
        @amount="setItemsPerPage"
      />
    </div>
  </div>
</template>

<script>
import MyFamiliesTable from '@/components/widgets/families/MyFamiliesTable';
import listPagesHeader from '@/components/widgets/lists/ListPagesHeader';
import FiltersBar from '@/components/widgets/dataTable/FiltersBar';
import BasePagination from '@/components/widgets/dataTable/BasePagination';

import Permissions from '@/constants/permissions';
import search from '@/mixins/search';

export default {
    name: 'FamilyList',
    components: { BasePagination, MyFamiliesTable, listPagesHeader, FiltersBar },
    mixins: [search],
    beforeRouteEnter (to, from, next) {
        next((vm) => {
            if (from.name !== 'family-card' && from.name !== 'preview-for-donor') {
                vm.$store.commit('search/clearFilter');
            }
        });
    },
    beforeRouteLeave (to, from, next) {
        if (to.name !== 'family-card') {
            this.$store.commit('search/clearFilter');
        }
        next();
    },
    data () {
        return {
            Permissions,
            myFamilies: {
                headers: [
                    {
                        text: this.$t('label.family_code'),
                        value: 'family_id',
                        sortable: false,
                        align: 'left',
                        desktopOnly: true
                    },
                    {
                        text: this.$t('label.family'),
                        value: 'last_name',
                        sortable: false,
                        sort: true,
                        desktopOnly: false,
                        icon: 'SortIcon',
                        sortingType: 1
                    },
                    {
                        text: this.$t('label.address'),
                        value: 'address',
                        sortable: false,
                        sort: true,
                        desktopOnly: true,
                        icon: 'SortIcon',
                        sortingType: 1
                    },
                    { text: this.$t('label.volunteers'), value: '', sortable: false, desktopOnly: true },
                    { text: this.$t('label.status'), value: '', sortable: false, desktopOnly: false },
                    {
                        text: this.$t('label.last_status_change_date'),
                        value: 'last_status_change_date',
                        sortable: false,
                        sort: true,
                        desktopOnly: true,
                        icon: 'SortIcon',
                        sortingType: 1
                    }
                ]
            }
        };
    },
    computed: {
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        getQualifiedFamilies () {
            return this.$store.getters['familyData/getQualifiedFamilies'];
        },
        amountAll () {
            return this.getQualifiedFamilies.amount ? this.getQualifiedFamilies.amount : 0;
        },
        filter () {
            return this.$store.getters['search/getFilter'];
        }
    },
    methods: {
        setPage (event) {
            this.$store.commit('familyData/setQualifiedFamiliesPagination', {
                page: event
            });
            this.fetchMyFamilies();
        },
        setItemsPerPage (event) {
            this.$store.commit('familyData/setQualifiedFamiliesPagination', {
                amount: event,
                page: 1
            });
            this.fetchMyFamilies();
        },
        fetchMyFamilies () {
            const filters = this.getFiltersWithValue();
            this.$store.dispatch('familyData/getMyFamilies', filters);
        }
    }
};
</script>

<style scoped></style>
